import type { AxiosResponse } from "axios";
import type { UUID } from "crypto";
import { apiClientMainV2 } from "../../../lib/client-api";
import { Mapper } from "../../../lib/utils/mapper";
import type { IPersonaUpsert } from "../../../types/persona/persona-upsert/persona-upsert.entity.interface";
import { Persona } from "../../../types/persona/persona.entity";
import { PersonaUpsertDto } from "./dto/persona-upsert/persona-upsert.dto";
import type { IPersonaUpsertDto } from "./dto/persona-upsert/persona-upsert.dto.interface";
import { PersonaDto } from "./dto/persona/persona.dto";
import type { IPersonaDto } from "./dto/persona/persona.dto.interface";

const PERSONA_ENDPOINT = "/persona/";

export async function getCurrentCitizenPersona(): Promise<Persona> {
  const response = await apiClientMainV2.get<IPersonaDto>(PERSONA_ENDPOINT);
  const dto = Mapper.mapData(PersonaDto, response.data);
  const entity = Mapper.mapData(Persona, dto);
  return entity;
}

export async function upsertPersona(personaId: UUID, payload: IPersonaUpsert): Promise<Persona> {
  const upsertDto = Mapper.mapData(PersonaUpsertDto, payload);
  const url = `${PERSONA_ENDPOINT}${personaId}`;

  const response = await apiClientMainV2.patch<IPersonaDto, AxiosResponse<IPersonaDto>, IPersonaUpsertDto>(
    url,
    upsertDto
  );
  const dto = Mapper.mapData(PersonaDto, response.data);
  const entity = Mapper.mapData(Persona, dto);

  return entity;
}
